export const GATEWAY_CONFIG = {
  safe2pay: {
    id: 'safe2pay',
    name: 'Safe2Pay',
    methods: {
      cartao: {
        enabled: true,
        baseFee: 0.11,
        installmentFees: {},
      },
      boleto: {
        enabled: true,
        baseFee: 0,
      },
      pix: {
        enabled: true,
        baseFee: 0,
      },
    },
  },
  mercadopago: {
    id: 'mercadopago',
    name: 'Mercado Pago',
    methods: {
      cartao: {
        enabled: true,
        baseFee: 0.0498,
        installmentFees: {
          2: 0.0152,
          3: 0.02,
          4: 0.025,
          5: 0.03,
          6: 0.035,
          7: 0.04,
          8: 0.048,
          9: 0.06,
          10: 0.065,
          11: 0.072,
          12: 0.0819,
        },
      },
      boleto: {
        enabled: false,
        baseFee: 0,
      },
      pix: {
        enabled: false,
        baseFee: 0,
      },
    },
  },
};

export function calculateGatewayFee(gatewayId, paymentMethod, installments = 1) {
  const gateway = GATEWAY_CONFIG[gatewayId];

  if (!gateway) {
    console.warn(`Gateway ${gatewayId} não encontrado`);
    return 0;
  }

  const method = gateway.methods[paymentMethod];

  if (!method || !method.enabled) {
    return 0;
  }

  let totalFee = method.baseFee;

  if (installments > 1 && method.installmentFees) {
    const installmentFee = method.installmentFees[installments] || 0;
    totalFee += installmentFee;
  }

  return totalFee;
}

export function calculateValueWithFee(originalValue, feePercentage) {
  if (feePercentage === 0) {
    return originalValue;
  }
  return originalValue / (1 - feePercentage);
}

export function calculateFeeAmount(originalValue, feePercentage) {
  const valueWithFee = calculateValueWithFee(originalValue, feePercentage);
  return valueWithFee - originalValue;
}

export function getAvailableGateways() {
  return Object.values(GATEWAY_CONFIG).map((gateway) => ({
    id: gateway.id,
    name: gateway.name,
  }));
}

export function isPaymentMethodAvailable(gatewayId, paymentMethod) {
  const gateway = GATEWAY_CONFIG[gatewayId];
  if (!gateway) return false;

  const method = gateway.methods[paymentMethod];
  return method?.enabled || false;
}

export function formatFeePercentage(feePercentage) {
  return `${(feePercentage * 100).toFixed(2).replace('.', ',')}%`;
}
